import { BaseModel } from "./hateoas/base-model";

export class ManagerModel extends BaseModel {
  idUser?: number;
  userCreateId?: number;
}
